import { useTranslation } from '@pancakeswap/localization'
import { useMatchBreakpoints } from '@pancakeswap/uikit'
import { useWeb3React } from '@pancakeswap/wagmi'
import Container from 'components/Layout/Container'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { useEffect } from 'react'
import { fetchAddressResult } from 'state/predictions'
import { useGetOrFetchLeaderboardAddressResult } from 'state/predictions/hooks'
import styled from 'styled-components'
import { useConfig } from 'views/Predictions/context/ConfigProvider'
import MyRankingRow from './MyRankingRow'

const ConnectedWalletResult = () => {
  const { account } = useWeb3React()
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  const accountResult = useGetOrFetchLeaderboardAddressResult(account)
  const { isDesktop } = useMatchBreakpoints()
  const { token } = useConfig()

  useEffect(() => {
    if (account) {
      dispatch(fetchAddressResult(account))
    }
  }, [account, dispatch])

  if (!account || !accountResult) {
    return null
  }

  return (
    <StyleContainer mb="48px">
      <StyleTitle color="white">{t('My Rankings')}</StyleTitle>
      {/* {isDesktop ? ( */}
      <StyleTable>
        <StyleHead>
          <div>&nbsp;</div>
          <div>{t('PnL', { symbol: token.symbol })}</div>
          <div>{t('Win Rate')}</div>
          <div>{t('Rounds Won')}</div>
          <div>{t('Rounds Played')}</div>
        </StyleHead>

        <StyleBody>
          <MyRankingRow user={accountResult} />
        </StyleBody>
      </StyleTable>
    </StyleContainer>
  )
}

const StyleTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 16px;
  color: #fff;
`
const StyleContainer = styled(Container)`
  height: fit-content;
  @media screen and (max-width: 700px) {
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 24px;
  }
`
const StyleHead = styled.div`
  display: grid;
  grid-template-columns: 330px repeat(4, 1fr);
  div {
    color: rgba(255, 255, 255, 0.6);

    font-size: 14px;
    text-transform: none;
    font-weight: 400;
    line-height: 140%;
  }

  @media screen and (max-width: 967px) {
    display: none;
  }
`
const StyleBody = styled.div``

const StyleTable = styled.div`
  height: fit-content;
  width: 100%;
  border-radius: 16px;

  border-radius: 16px;
  border: solid 1px transparent;
  background: linear-gradient(#1b1e22 0 0) padding-box, linear-gradient(to right, #ff4fed, #03f5ae) border-box;

  /* background: var(--Border, rgba(255, 255, 255, 0.1)); */
  padding: 24px;

  @media screen and (max-width: 967px) {
    padding: 16px;
  }
`
export default ConnectedWalletResult
